import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9h18","key":"svg-0"}],["path",{"d":"M3 15h18","key":"svg-1"}],["path",{"d":"M8 4c.485 .445 3.5 3.312 3.5 8c0 .663 -.07 4.848 -3.5 8","key":"svg-2"}],["path",{"d":"M15 4a17 17 0 0 1 2.004 8c0 1.51 -.201 4.628 -2.004 8","key":"svg-3"}],["path",{"d":"M18.778 20h-13.556a2.22 2.22 0 0 1 -2.222 -2.222v-11.556c0 -1.227 .995 -2.222 2.222 -2.222h13.556c1.227 0 2.222 .995 2.222 2.222v11.556a2.22 2.22 0 0 1 -2.222 2.222","key":"svg-4"}]]

const IconMesh = createReactComponent('outline', 'mesh', 'Mesh', __iconNode);

export default IconMesh;